import operationTypesRealNames from 'constants/operationTypesRealNames';
import { format } from 'date-fns';
import { translate } from 'hooks/useTranslate';
import { Operation, Society } from 'types';

export const getDocumentTitle = (
  society: Society,
  operation: Operation | undefined
) => {
  if (!operation) {
    return '';
  }

  const operationType = operation?.alias || operation.operationType;

  const operationName = translate(operationTypesRealNames[operationType]);

  const operationDate = operation?.date
    ? format(new Date(operation.date), 'dd-MM-yyyy')
    : '';

  return `${society?.name || ''} - ${operationName} ${operationDate}`;
};
